import { Divider, Grid, Label, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";

import {
  equipmentParametersByEquipmentID,
  equipmentTypeParametersByEquipmentTypeID,
  getEquipment,
  listParameters,
} from "graphql/queries";

const ParametersInfo = ({ equipmentID }) => {
  const [parameters, setParameters] = useState({ data: [], loading: false });

  const getParametersData = async (id) => {
    try {
      setParameters({ data: [], loading: true });

      const equipmentData = await API.graphql(
        graphqlOperation(getEquipment, { id })
      );
      const equipmentItem = equipmentData.data.getEquipment;

      const parametersRelData = await API.graphql(
        graphqlOperation(equipmentParametersByEquipmentID, {
          equipmentID: id,
          filter: {
            deletedAt: { attributeExists: false },
          },
        })
      );
      let parametersRelItems =
        parametersRelData.data.equipmentParametersByEquipmentID.items;

      if (equipmentItem.equipmentTypeID) {
        const parametersRelTypeData = await API.graphql(
          graphqlOperation(equipmentTypeParametersByEquipmentTypeID, {
            equipmentTypeID: equipmentItem.equipmentTypeID,
            filter: {
              deletedAt: { attributeExists: false },
            },
          })
        );
        const parametersRelTypeItems =
          parametersRelTypeData.data.equipmentTypeParametersByEquipmentTypeID
            .items || [];

        parametersRelItems = [
          ...parametersRelItems,
          ...parametersRelTypeItems.map((p) => ({ ...p, byType: true })),
        ];
      }

      if (parametersRelItems.length > 0) {
        const parametersData = await API.graphql(
          graphqlOperation(listParameters, {
            filter: {
              or: parametersRelItems.map((paramRel) => ({
                id: { eq: paramRel.parameterID },
              })),
            },
          })
        );
        const parametersItems = parametersData.data.listParameters.items;

        setParameters((prev) => ({
          ...prev,
          data: parametersItems.map((param) => {
            const modelFound = parametersRelItems.find(
              (paramRel) => paramRel.parameterID === param.id
            );

            return {
              ...param,
              value: modelFound.parameterValue,
              byType: modelFound.byType,
            };
          }),
        }));
      }
    } catch (err) {
      toast.error(strings.errors.fetchParameters);
    } finally {
      setParameters((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (equipmentID) getParametersData(equipmentID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.parameters}</span>
        {parameters.loading ? (
          <Loader />
        ) : (
          <Grid gap="5px">
            {parameters.data.length > 0
              ? parameters.data.map((parameter, index) => (
                  <>
                    {index > 0 && <Divider className="my-2" />}
                    <Grid gap="25px" templateColumns={{ base: "1fr 1fr" }}>
                      <Grid>
                        <Label>{parameter.name}</Label>
                        <span className="text-muted">
                          {parameter.value} {parameter.unit}
                        </span>
                      </Grid>
                      {/* <Grid>
                        <Label>{strings.value}</Label>
                        <span className="text-muted">
                          {parameter.value} {parameter.unit}
                        </span>
                      </Grid> */}
                    </Grid>
                  </>
                ))
              : strings.noParameters}
          </Grid>
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    parameters: "Parámetros del Equipo",
    name: "Nombre",
    value: "Valor",
    errors: {
      fetchParameters: "Error al consultar los parámetros",
    },
    noParameters: "Sin parámetros...",
  },
});

export default ParametersInfo;
